import * as React from 'react';

function SvgComponent(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={17}
            viewBox="0 0 18 17"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_701_1396)">
                <path
                    d="M0 4.394h3.433l1.999 5.114 2.025-5.114h3.342L5.766 16.501H2.402l1.378-3.208L0 4.394zm14.691 4.087h-3.743L14.27.499H18L14.691 8.48zm-2.763.764a2.08 2.08 0 110 4.159 2.08 2.08 0 010-4.16z"
                    fill="#5F01D1"
                />
            </g>
            <defs>
                <clipPath id="clip0_701_1396">
                    <path
                        fill="#fff"
                        transform="translate(0 .499)"
                        d="M0 0H18V16.0022H0z"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}

export default SvgComponent;
